const actions = {
    CHECK_STATUS: "CHECK_STATUS",
    CHECK_STATUS_SUCCESS: "CHECK_STATUS_SUCCESS",
    CHECK_STATUS_FAILED: "CHECK_STATUS_FAILED",

    CHECK_DATA_USAGE: "CHECK_DATA_USAGE",
    CHECK_DATA_USAGE_SUCCESS: "CHECK_DATA_USAGE_SUCCESS",
    CHECK_DATA_USAGE_FAILED: "CHECK_DATA_USAGE_FAILED",

    RESET_MESSAGE: 'RESET_MESSAGE',


    checkStatus: (data) => ({
        type: actions.CHECK_STATUS,
        payload: { data },
    }),
    checkStatusSuccess: (data) => ({
        type: actions.CHECK_STATUS_SUCCESS,
        payload: { data },
    }),
    checkStatusError: (error) => ({
        type: actions.CHECK_STATUS_FAILED,
        payload: { error },
    }),

    checkDataUsage: (data) => ({
        type: actions.CHECK_DATA_USAGE,
        payload: { data },
    }),
    checkDataUsageSuccess: (data) => ({
        type: actions.CHECK_DATA_USAGE_SUCCESS,
        payload: { data },
    }),
    checkDataUsageError: (error) => ({
        type: actions.CHECK_DATA_USAGE_FAILED,
        payload: { error },
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),

}

export default actions;
